import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    tileWrapper: 'flex flex-col gap-6',
    base: 'relative z-0 flex gap-6 max-md:gap-2',
    link: 'absolute inset-0 z-10 cursor-pointer',
    imageContainer:
      'relative bg-white max-md:col-start-1 max-md:row-start-1 max-md:flex max-md:flex-col max-md:items-center max-md:justify-center max-md:gap-4 max-md:pb-2 max-sm:z-20',
    image: 'size-full object-contain max-md:size-[100px] md:size-[120px]',
    giftLabel:
      'heading-xs-bold absolute right-1/2 bottom-0 translate-x-1/2 translate-y-1/2',

    content: 'flex flex-1 flex-col gap-3',
    header: 'relative z-20 flex flex-row items-center gap-3',
    info: 'flex h-full flex-col justify-between',
    title:
      'heading-s-intr-regular mb-1 line-clamp-2 flex leading-tight max-md:mb-3',
    titleText: 'grow',
    description: 'heading-xs lg:heading-s line-clamp-2',

    productActions:
      'relative z-20 flex h-full flex-col gap-1 max-md:col-start-2 max-md:row-start-2 md:w-[64px]',
    priceRow: 'mb-1 flex flex-col',
    priceCounterWrapper:
      'flex w-full items-center justify-between max-md:flex-col max-md:items-start max-md:gap-4',
    price:
      'flex-col gap-[2px] max-md:flex-row max-md:items-center max-md:gap-2',
    salePrice: 'heading-xs text-secondary-hover flex flex-row gap-1 text-sm',
    controls:
      'bg-system-gray-100 relative z-20 flex !w-[160px] flex-row items-center justify-between',
    count: 'heading-xs text-secondary-hover',
    buy: 'mt-4 w-full',
    countFree: 'heading-xs text-secondary-hover mt-3',
    actions:
      'max-md:align-self-end relative z-20 flex items-center gap-4 max-md:w-full md:justify-end',
    actionItem: 'link max-md:h-[24px]',
    wishlistItem: 'min-w-6',
    percentLabel:
      'text-12 mt-px-0 ml-px-0 absolute z-10 px-2 py-1 font-[450] text-white',
    outOfStockText: 'heading-xs text-label-red font-[450]',
    subscribeButton: 'z-20',
    points: 'flex items-center justify-start gap-1 text-xs',
    pointsIcon: 'h-4 w-4',
    pointsInfoIcon: 'relative z-100 h-4.5 w-4.5 cursor-pointer',
    tooltip: 'heading-xs max-w-[184px]'
  },
  variants: {
    type: {
      base: '',
      gift: '',
      order: '',
      unavailable: {
        imageContainer: 'opacity-50',
        titleText: 'opacity-50'
      },
      sample: ''
    },
    isInWishlist: {
      true: {
        actionItem: '!opacity-100'
      }
    }
  },
  defaultVariants: {
    type: 'base'
  }
});
